import { render, staticRenderFns } from "./AuthorityGroupsManagement.vue?vue&type=template&id=3f3f1492&scoped=true&"
import script from "./AuthorityGroupsManagement.vue?vue&type=script&lang=js&"
export * from "./AuthorityGroupsManagement.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityGroupsManagement.vue?vue&type=style&index=0&id=3f3f1492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3f1492",
  null
  
)

export default component.exports